module.exports = __webpack_public_path__ + "addeparStep1Authorization.b967f77f52682ed525ca52ed43b27f16.png";